var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTopbar)?_c('div',{staticClass:"adbox-topbar"},[_c('img',{attrs:{"src":_vm.activityData.imgUrl,"alt":""},on:{"click":function($event){return _vm.openLink(_vm.activityData.linkUrl)}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }